import { DataViewHeader, Flex, csx } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'

export function TableHeader(props: DefaultProps) {
  return (
    <DataViewHeader>
      <Flex direction="column" className={csx({ width: 'full' })}>
        <Flex
          direction="row"
          align="center"
          className={csx({ paddingBottom: '$space-5' })}
        >
          {props.children}
        </Flex>
      </Flex>
    </DataViewHeader>
  )
}
